
<div>
  <br>
  <div [hidden]="!ShowWithdrawnApplications" >
    <mat-toolbar class="form-toolbar"
    fxShow.gt-sm fxHide.lt-md>
    <span class="form-action-title">
      APPLICATIONS WITHDRAWN
    </span>
    
  </mat-toolbar>
  <div fxHide.gt-sm fxShow.lt-md>
    <div>
      <div class="form-action-title">APPLICATIONS WITHDRAWN</div>
     
    </div>
    <mat-divider></mat-divider>
    </div>
    <div [hidden]="!toggleDisplayCardList">
      <div fxLayout="row wrap" fxLayout.xs="column wrap" style="margin-top: 18px;">
        <div *ngFor="let application of data" fxFlex.gt-xs="50%" [fxFlex.gt-md]="cardLayout">
          <div style="margin-top: 10px; margin-right: 10px;">
            <mat-card [class.mat-elevation-z7]='true'>
              <!-- Card Title -->
              <mat-card-title style="font-size: 16px;">{{application.name}}</mat-card-title>
             
              <mat-divider></mat-divider>
              <!-- Card Body -->
              <div style="margin-top: 32px !important">
                <mat-card-content>
                  <div>
                    <span>
                      <span class="card-label">Program</span>
                      <span class="card-value">
                        {{application._Ebb_ProgramCycleId_Formatted}}
                       
                      </span>
                    </span>
                  </div>
                  <div style="margin-top: 9px;">
                    <div >
                      <span class="card-label">Status</span>
                     
                    
                        <div  class="card-value" >
                          <span class="accent-text">
                           Withdrawn ({{getFormattedDate(application.withdrawnDate)}})
                          </span>                        
                        </div>

                     
                    </div>
                   
                  </div>
                
                </mat-card-content>
              </div>
              <mat-divider></mat-divider>
             
            </mat-card>
          </div>
        </div>
      </div>
     
    </div>

    

  </div>
</div>
  
